export enum EmailOrMobileEnum {
    Email = 1,
    Sms = 2
}
